import React, { useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    TextField,
    InputAdornment, Rating, ListItemSecondaryAction, ListItemText, ListItem, List, DialogContent, Dialog,Button, DialogActions, DialogTitle,
    Stepper, Step, StepLabel
} from "@mui/material";
import {ArrowUpward, AttachFile, Delete} from "@material-ui/icons";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import ListItemIcon from "@material-ui/core/ListItemIcon";

const CPCProgramRating = ({ data, actions, options }) => {
    const classes = useStyles();
    const { uploadedFiles, currentStatus, RATING_STEPS } = data;
    const { showPopup } = options;
    const { uploadFileAction, deleteFileAction, submitAction, setShowPopup } = actions;
    const [dragging, setDragging] = useState(false);

    const activeStep = RATING_STEPS.findIndex(step => step.status === currentStatus);

    const handleFileUpload = (event) => {
        event.preventDefault();
        const files =
            event.dataTransfer?.files
                ? Array.from(event.dataTransfer.files) // Drag-and-drop
                : Array.from(event.target.files);
        if (files.length === 0) {
            console.log("Please select at least one file to upload.");
            return;
        }
        // Filter out duplicates
        const uniqueFiles = files.filter(
            (file) => !uploadedFiles.some((uploaded) => uploaded.name === file.name)
        );

        if (uniqueFiles.length === 0) {
            console.log("No new files to upload.");
            return;
        }

        // Call the uploadFileAction here without showing the popup immediately
        uploadFileAction(uniqueFiles);

        // Reset the input field for file selection (optional)
        // if (event.target) {
        //     event.target.value = null; // Clear the input
        // }
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const handleRemoveFile = (index) => {
        deleteFileAction(index);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        handleFileUpload(event);
    };

    const handleSubmit = () => {
        submitAction();
    };

    return (
        <>
        <Box sx={{ p: 3 }}>
            <Stepper
                activeStep={activeStep}
                alternativeLabel
                sx={{
                    '& .MuiStepLabel-root .Mui-completed': {
                        color: '#ff6468ff'
                    },
                    '& .MuiStepLabel-root .Mui-active': {
                        color: '#ff6468ff'
                    },
                    '& .MuiStepLabel-root .Mui-disabled': {
                        color: '#ff6468ff',
                        opacity: 0.5
                    },
                    '& .MuiStepConnector-root .MuiStepConnector-line': {
                        borderColor: '#ff6468ff',
                        borderTopWidth: '6px',
                        // marginTop: '-12px'
                    }
                }}
            >
                {RATING_STEPS.map((step) => (
                    <Step key={step.label}>
                        <StepLabel
                            StepIconProps={{
                                sx: {
                                    '&.Mui-completed': {
                                        color: '#ff6468ff',
                                        fontSize: '1.7rem',
                                        '& .MuiStepIcon-text': {
                                            display: 'none'
                                        }
                                    },
                                    '&.Mui-active': {
                                        color: '#ff6468ff',
                                        fontSize: '1.7rem',
                                        '& .MuiStepIcon-text': {
                                            display: 'none'
                                        }
                                    },
                                    fontSize: '1.7rem',
                                    '& .MuiStepIcon-text': {
                                        display: 'none'
                                    }
                                }
                            }}
                        >
                            {step.label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>

        {currentStatus === 'UPLOADING' && (

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 4,
                }}
            >
                <Typography
                    variant="h3" sx={{ marginBottom: 3 }} className={classes.title}
                >
                    What’s Your Program’s DQ Stars Rating?
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
                    <Rating
                        value={3}
                        max={3}
                        readOnly
                        icon={<span style={{ color: "#FFD700", fontSize: "80px" }}>★</span>}
                        emptyIcon={<span style={{ color: "#E0E0E0", fontSize: "80px" }}>★</span>}
                    />
                </Box>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: "1.2rem",
                        textAlign: "left",
                        marginBottom: 2,
                        maxWidth: "930px",
                    }}
                >
                    Here we will evaluate your digital citizenship education program in just 10–15 minutes. Simply upload your learning materials, complete a short form about your organization, and receive a detailed DQ Stars Report and Rating based on global benchmarks.
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontSize: "1.2rem",
                        textAlign: "left",
                        marginBottom: 2,
                        maxWidth: "630px",
                    }}
                >
                    What to upload <span style={{ color: '#ff6468', fontStyle: 'italic', fontWeight: 'normal' }}>(multiple files allowed):</span>
                    <ul style={{ textAlign: 'left', display: 'inline-block', marginTop: '5px' }}>
                        <li>Program materials in <strong>Word or PDF format</strong></li>
                        <li><strong>Learning content</strong> for children and youth under 18</li>
                        <li><strong>Resources</strong> for parents, caregivers, educators, or facilitators</li>
                        <li><strong>Supporting documents</strong> related to your program</li>
                    </ul>
                </Typography>

                {uploadedFiles.length > 0 && (
                    <Box mb={2} style={{ width: "100%", maxWidth: "700px", border: '1px solid #ED6628', borderRadius: '7px', padding: '10px' }}>
                        <Typography variant="h6" style={{ color: '#ED6628' }}>Uploaded Files:</Typography>
                        <List>
                            {uploadedFiles.map((file, index) => (
                                <ListItem key={index}>
                                    <ListItemIcon>
                                        <InsertDriveFileIcon style={{ color: '#ED6628' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={file.name} />
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            edge="end"
                                            style={{ color: '#ED6628' }}
                                            onClick={() => handleRemoveFile(index)}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}

                <Box
                    className={classes.fileUploadContainer}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    <TextField
                        fullWidth
                        placeholder="Click here to upload file"
                        sx={{
                            backgroundColor: dragging ? "#fff5f0" : "#fff",
                            borderRadius: '10px',
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "1px solid #ED6628",
                                },
                                "&:hover fieldset": {
                                    border: "1px solid #ED6628",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "1px solid #ED6628",
                                },
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton component="label" onClick={(e) => e.stopPropagation()}>
                                        <AttachFile />
                                        <input
                                            hidden
                                            type="file"
                                            multiple
                                            accept=".pdf,.doc,.docx"
                                            onChange={handleFileUpload}
                                        />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            document.querySelector('input[type="file"]').click();
                                        }}
                                        sx={{
                                            backgroundColor: "#ED6628",
                                            color: "#fff",
                                            "&:hover": {
                                                backgroundColor: "#ED6628",
                                            },
                                        }}
                                    >
                                        <ArrowUpward />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            readOnly: true,
                        }}
                        onClick={() => document.querySelector('input[type="file"]').click()}
                    />
                </Box>

                <Box display="flex" gap={2} sx={{ mt: 5 }}>
                    <Button
                        className={classes.actionButton}
                        variant="contained"
                        color="secondary"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleSubmit();
                        }}
                        disabled={uploadedFiles.length === 0}
                        sx={{
                            backgroundColor: uploadedFiles.length === 0 ? "#D3D3D3" : "#ED6628", // Gray out when no file uploaded
                            "&:hover": {
                                backgroundColor: uploadedFiles.length === 0 ? "#D3D3D3" : "#ED6628",
                            },
                        }}
                    >
                        SUBMIT
                    </Button>
                </Box>
            </Box>
        )}
            {/* Popup Dialog */}
            <Dialog maxWidth="md" fullWidth PaperProps={{style: {
                    width: '30%',
                    height: '33%',
                    maxWidth: 'none',
                    borderRadius:'20px',
                    paddingTop:'20px',
                },}} open={showPopup} onClose={handleClosePopup} style={{borderRadius:'20px !important'}}>
                <DialogTitle style={{textAlign:'center'}}>Your file has been uploaded.</DialogTitle>
                <DialogContent style={{textAlign:'center', fontWeight:'normal'}}>
                    <Typography variant="h7" style={{textAlign:'center',lineHeight:'1.1', fontSize:'18px'}}>
                        To add another file, click to upload another file.
                        <br /> <br/>
                        If you’re done, click <strong>SUBMIT</strong>. You cannot go back, so make sure you have uploaded all your files.
                    </Typography>
                </DialogContent>
                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '15px', marginBottom: '20px' }}>
                    <Button
                        variant="contained"
                        style={{  backgroundColor:'#ff6468ff !important' , }}
                        className={classes.dialogButton}
                        onClick={handleClosePopup}
                    >
                        OK
                    </Button>
                </Box>
            </Dialog>
        </>
    );
};

export default CPCProgramRating;